import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_application.svg'
import _imports_1 from '@/assets/images/logo_company.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e5c2f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "content-page welcome-page"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "logo",
  height: "30"
}, null, -1))
const _hoisted_4 = { class: "comment" }
const _hoisted_5 = { class: "comment__header" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "error" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "company",
  src: _imports_1,
  alt: "company",
  height: "75"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_crm_spinner = _resolveComponent("crm-spinner")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_ctx.isAuthenticating)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_crm_spinner)
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("Welcome.HelloText")), 1),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("Welcome.CommentHeader")), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("Welcome.CommentText1")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("Welcome.CommentText2")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("Welcome.CommentText3")), 1)
            ])
          ]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            class: "login-button",
            type: "primary",
            onClick: _ctx.openLogin
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Welcome.SigninButton")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("footer", null, [
          _createVNode(_component_el_link, {
            class: "signup",
            type: "primary",
            icon: "el-icon-edit-outline",
            target: "_blank",
            href: "https://www.mobifactory.fr/essai-gratuit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Welcome.SignupLink")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            innerHTML: _ctx.$t('Welcome.FooterText1', [_ctx.appVersion, _ctx.year])
          }, null, 8, _hoisted_8),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("Welcome.FooterText2")), 1),
          _hoisted_9
        ])
      ]))
}